<template>
  <fragment>
    <v-col cols="12" class="p-5">
      <div class="p-5" style="max-width: 97vw">
        <p class="text-justify" v-html="_messageInfoService.getExplanation('confort')"></p>
      </div>
    </v-col>
    <v-row class="ml-5 mb-3">
      <v-col
        class="col-12 col-sm-6 pb-0 pt-0"
        style="padding: 0px; margin: 0px"
        :key="'list-acc-' + ind"
        v-for="(acc, ind) in itens"
      >
        <v-switch
          :label="acc.label"
          placeholder=" "
          v-model="acc.check"
          class="switch-base"
          style="padding: 0px; margin: 0px"
          @change="setConforto(acc)"
        />
      </v-col>
    </v-row>
    <v-col cols="12" v-if="model.accommodation && model.accommodation.length > 0">
      <v-btn color="botao" @click="selecionar()" block>
        <v-icon small left>fas fa-check</v-icon>Continuar
      </v-btn>
    </v-col>
  </fragment>
</template>

<script>
import { mapMutations } from "vuex";
import InsurancePricingService from "../services/salesforce/InsurancePricingService";
import MessageInfoService from "../services/salesforce/MessageInfoService";
import store from "../store/store";
import { Fragment } from "vue-fragment";

export default {
  components: { Fragment },
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      itens: [],
    };
  },
  beforeCreate() {
    this._insurancePricingService = new InsurancePricingService();
    this._messageInfoService = new MessageInfoService();
  },
  mounted() {
    this.getItens();
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    selecionar() {
      this.$emit("selecionar");
    },
    SemDados() {
      this.$emit("semdados");
    },
    naoDisponivel() {
      store.commit("showmsg", {
        text: this._messageInfoService.getExplanation("nao-disponivel"),
        type: "warning",
      });
    },
    setConforto(item) {
      if (this.model.accommodation.some((s) => s.label == item.label)) {
        this.model.accommodation = this.model.accommodation.filter(
          (f) => f.label != item.label
        );
      } else this.model.accommodation.push(item);
    },
    async getItens() {
      if (!(this.model.loadquote && this.model.loadquote)) {
        this.toogleDialogLoading(true);
      }
      console.log("city: "+this.model.region.Id);
      console.log("studyconfig: "+this.model.selectProjeto.id);
      
      await this._insurancePricingService
        .getAcomodacoes(this.model.region.Id, this.model.selectProjeto.id)
        .then((res) => {
          if (!res.data || res.data.length <= 0) {
            this.naoDisponivel();
            this.SemDados();
          } else {
            this.itens = res.data;
            if (this.model.loadquote && this.model.accommodation) {
              this.model.accommodation.forEach((acc) => {
                if (acc.check) {
                  this.itens.forEach((item) => {
                    if (item.label == acc.label) {
                      item.check = true;
                    }
                  });
                }
              });

              this.selecionar();
            } else {
              this.model.accommodation = [];
            }
          }
        })
        .finally(() => {
          if (!(this.model.loadquote && this.model.loadquote)) {
            this.toogleDialogLoading(false);
          }
        });
    },
  },
};
</script>
